import axios from '@/axios'

export default {
  getData (options = {}) {
    return axios.get('/about', options)
  }
}